import React from 'react';
import SubCategoryScreenView from './SubCategoryScreenview';
import { SubCategoryContextProvider } from '../../context/SubCategoryContext';

const SubCategoryView = () => {
    return (
        <SubCategoryContextProvider>
            <SubCategoryScreenView />
        </SubCategoryContextProvider>
    );
};

export default SubCategoryView;
